<template>
  <div>
    <v-btn
      class="ma-2 no-display"
      tile
      outlined
      color="warning"
      @click="print()"
    >
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>
    <div id="document1" class="printdiv text-color" v-if="lc_data != null">
      <!-- <v-row>
        <v-col class="pb-0 pt-0" cols="6" sm="6" md="6" align="left"
          >UDISE No. {{ lc_data.udise_no }}</v-col
        >
        <v-col class="pb-0 pt-0" cols="6" sm="6" md="6" align="right"
          >College Index No.
          <span>J 5608031</span>
        </v-col>
      </v-row> -->
      <!-- <hr /> -->
      <v-row style="height: 260px;">
        <!-- <v-col cols="2" sm="2" md="2">
          <center>
            <img
              :src="org_basic_data.school_logo"
              alt="school_logo"
              height="120px"
              width="170px"
            />
          </center>
        </v-col>
        <v-col cols="9" sm="9" md="9">
          <center>
            <span>{{ org_basic_data.trust_name }}</span>
            <h1>{{ org_basic_data.school_name }}</h1>
            <span
              >(Affiliated to Maharashtra State Board of Secondary and Higher
              Secondary Education, Pune.)</span
            ><br />
            <span> {{ org_basic_data.address }}- {{ org_basic_data.pin }}</span>
            <br />
          </center>
        </v-col> -->
      </v-row>
      <!-- <v-row>
        <v-col cols="12" sm="12" md="12" class="pb-0 pt-0"
          >School Recog. No. <span>{{ lc_data.school_code }}</span></v-col
        >
      </v-row> -->
      <v-row>
        <v-col class="pt-0" cols="3" sm="3" md="3">
          Certificate No. {{ lc_data.certificate_no }}
        </v-col>
        <v-col class="pt-0" cols="6" sm="6" md="6">
          <!-- <center>
            <h2 style="color: rgb(235, 61, 61); font-size: 32px">
              LEAVING CERTIFICATE
            </h2>
          </center> -->
        </v-col>
        <v-col class="pt-0" cols="3" sm="3" md="3">
          G.R. No. {{ lc_data.gr_number }}
        </v-col>
      </v-row>
      <table class="jr-table">
        <tr>
          <td>APAAR ID</td>
          <td colspan="2">{{ lc_data.apaar_id }}</td>
        </tr>
        <tr>
          <td>PEN ID</td>
          <td colspan="2">{{ lc_data.pen_no }}</td>
        </tr>
        <tr>
          <td>Unique (Aadhaar No.)</td>
          <td colspan="2">{{ lc_data.aadhar_no }}</td>
        </tr>
        <tr>
          <td>1) Name of the Student</td>
          <td colspan="2">{{ lc_data.fullname }}</td>
        </tr>
        <tr>
          <td>2) Mother's Name</td>
          <td colspan="2">{{ lc_data.mother_first_name }}</td>
        </tr>
        <tr>
          <td>3) Nationality</td>
          <td style="width: 35%">{{ lc_data.nationality }}</td>
          <td>4) Mother Tongue - {{ lc_data.mothertoungue }}</td>
        </tr>
        <tr>
          <td>5) Religion, Caste & Sub-Caste</td>
          <td colspan="2">
            {{ lc_data.religion }}-{{ lc_data.caste }}-{{ lc_data.subcaste }}
          </td>
        </tr>
        <tr>
          <td style="line-height: 100%">
            6) Place of Birth <br />
            <span style="font-size: small; margin-left: 15px"
              >(Village/City, Taluka, Zilla, State, Country)</span
            >
          </td>
          <td colspan="2">{{ lc_data.birth_place }}</td>
        </tr>
        <tr>
          <td style="line-height: 100%">
            7) Date of Birth <br />
            <span style="font-size: small; margin-left: 15px"
              >(According to Christian era)</span
            >
          </td>
          <td colspan="2">{{ lc_data.dob_fig }}</td>
        </tr>
        <tr>
          <td style="line-height: 100%">
            8) Date of Birth <br />
            <span style="font-size: small; margin-left: 15px">(in words)</span>
          </td>
          <td colspan="2">{{ lc_data.dob_words }}</td>
        </tr>
        <tr>
          <td>9) Last School Name & Std.</td>
          <td colspan="2">{{ lc_data.last_school }} - {{ lc_data.previousschoolpassingstandard }}</td>
        </tr>
        <tr>
          <td>10) Date of Admission & Std.</td>
          <td>{{ lc_data.doa }}</td>
          <td>Std. - {{ lc_data.admittedstandard }}</td>
        </tr>
        <tr>
          <td>11) Progress</td>
          <td>{{ lc_data.progress }}</td>
          <td>12) Conduct : {{ lc_data.conduct }}</td>
        </tr>
        <tr>
          <td>13) Date of leaving the college</td>
          <td colspan="2">{{ lc_data.last_date_of_school }}</td>
        </tr>
        <tr>
          <td>
            14) Standard in which Studying & Since when
            <span style="font-size: small">(in words & figures)</span>
          </td>
          <td colspan="2">
            {{ lc_data.standard }} Since {{ lc_data.standard_since_when }}
          </td>
        </tr>
        <tr>
          <td>15) Reason for Leaving the college</td>
          <td colspan="2">{{ lc_data.reason }}</td>
        </tr>
        <tr>
          <td>16) Remarks</td>
          <td colspan="2">{{ lc_data.remark }}</td>
        </tr>
      </table>
      <div style="color: rgb(235, 61, 61); padding: 17px 0px 5px 17px">
        Certified that the above information is in accordance with the
        Institute's General Register No. {{ lc_data.gr_number }}
      </div>
      <span style="padding-left: 17px; color: rgb(235, 61, 61)"
        >Note: Any Changes in this Leaving Certificate will be liable for
        Punishment.</span
      ><br /><br />
      <span style="padding-left: 17px"
        >Certificate Issuing Date : {{ lc_data.date_of_issue }}</span
      >
      <v-row class="jr-last-row">
        <v-col cols="4" sm="4" md="4" align="center"
          ><b>CLASS TEACHER</b></v-col
        >
        <v-col cols="4" sm="4" md="4" align="center"><b>CLERK</b></v-col>
        <v-col cols="4" sm="4" md="4" align="center"><b>PRINCIPAL</b></v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      lc_data: null,
      org_basic_data: null,
    };
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
  },
  mounted() {
    this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
    this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
  },
};
</script>
<style scoped>
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: rgb(248, 248, 241);
  background-position: center;
}
.text-color {
  color: #233491;
  padding: 20px;
}
.jr-table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.jr-table td {
  word-break: break-word;
}
.jr-table td:nth-child(2) {
  border-right: none;
}
.jr-table td:first-child {
  width: 30% !important;
  border-left: none !important;
}
.jr-table,
.jr-table td,
.jr-table tr {
  border: 1px solid rgb(235, 61, 61);
  text-align: left;
  font-size: 17px;
}
.header {
  margin: 6px;
}
.last-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  /* margin-bottom: -15px; */
}
.lcdata {
  font-family: "Times New Roman", Times, serif;
}
.content {
  padding-bottom: 20px;
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(235, 61, 61);
}
.jr-last-row {
  color: rgb(235, 61, 61);
  margin-top: 90px;
  /* margin-bottom: 10px; */
}
/* lc data css end */

/* print lc css */
@media print {
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
  }
  #document1 {
    position: absolute;
    /* margin-top: -63px; */
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .text-color {
    padding: 20px !important;
    margin-left: -15px;
  }
  .jr-table,
  .jr-table td {
    /* height: 40px !important; */
    font-size: 20px !important;
  }
  .jr-last-row {
    margin-top: 110px !important;
    font-size: 20px !important;
  }
  @page {
    /* size: A4; */
    margin: none;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */
</style>